// Links that leave the public site open in a new tab: other domains, and the
// sign-up list in the panel, so the visitor keeps the page they came from.
// Done here rather than per template because links reach the page from many
// places — CMS link fields, rich text, hardcoded header buttons, event models.
export function openLeavingLinksInNewTab() {
  document.querySelectorAll("a[href]").forEach((link) => {
    const url = new URL(link.href, window.location.href);
    if (!url.protocol.startsWith("http")) return; // mailto:, tel:
    const offsite = url.origin !== window.location.origin;
    const signUp = !offsite && url.pathname.startsWith("/panel/courses");
    if (!offsite && !signUp) return;
    link.target = "_blank";
    link.relList.add("noopener");
  });
}
